<template>
  <v-card class="mr-3 ml-3 mb-3">
    <v-card-title class="headline justify-space-between">
      <div>
        <v-btn class="mr-3" color="green" dark to="/dealers/add">
          <v-icon>mdi-plus</v-icon>
          Добавить
        </v-btn>
        <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
      </div>

      <div>
        <v-text-field
          v-if="$store.getters.dealers"
          v-model="search"
          append-icon="mdi-magnify"
          label="Поиск"
          single-line
          hide-details
          class="pt-0"
        ></v-text-field>
      </div>
    </v-card-title>
    <v-data-table
      class="mb-3 mx-3"
      :search="search"
      :headers="headers"
      :items="$store.getters.dealers"
      :item-class="() => 'clickable-row'"
      no-data-text="Пусто"
      no-results-text="Результатов нет"
      @click:row="editDealer"
      hide-default-footer
      :loading="tableLoading"
      loading-text="Загрузка"
      :items-per-page="10"
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          :items-per-page-options="[10, 50, 100, -1]"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
        />
      </template>
      <template v-slot:item.moneyFor="{ item }">
        <span v-if="item.moneyFor != null && $store.getters.mappedOurLegalEntities[item.moneyFor]">{{ $store.getters.mappedOurLegalEntities[item.moneyFor].name }}</span>
        <span v-else>Не задано</span>
      </template>
      <template v-slot:item.updateTime="{ item }">
        <span>{{ formatUpdateTime(item.updateTime) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  data() {
    return {
      tableLoading: true,
      deleteDialog: false,
      search: "",
      // showDeleted: false,
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "Название",
          align: "start",
          value: "name",
        },
        {
          text: "Страна",
          align: "start",
          value: "country",
        },
        {
          text: "Город",
          align: "start",
          value: "city",
        },
        {
          text: "Телефон",
          align: "start",
          value: "phone",
          sortable: false,
        },
        {
          text: "Email",
          align: "start",
          value: "email",
          sortable: false,
        },
        {
          text: "Деньги кому?",
          align: "start",
          value: "moneyFor",
        },
        {
          text: "Доп. инфо",
          align: "start",
          value: "description",
          sortable: false,
        },
        {
          text: "Изменил",
          align: "start",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
      ],
    };
  },
  methods: {
    exportToFile(format) {
      API.get(`dealers/report?format=${format}`, { responseType: 'blob' })
      .then(response => {
      if (response.status === 200) {
        let contentType = '';
        let fileExtension = '';
        if (format === 'csv') {
          contentType = 'text/csv';
          fileExtension = '.csv';
        } else if (format === 'xlsx') {
          contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          fileExtension = '.xlsx';
        }
        const blob = new Blob([response.data], { type: contentType });
        const date = new Date();
        const currentDate = this.formatUpdateTime(date); 
        const filename = `Отчет дилеры ${currentDate}${fileExtension}`.replace(/:/g, '.');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
        console.log('Файл успешно загружен');
      } else {
        console.error('Ошибка загрузки файла:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Ошибка загрузки файла:', error);
    });
},
    editDealer(row) {
      this.$router.push("/dealers/" + row.id);
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "dealers", disabled: true },
    ]);
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("updateDealers"),
      this.$store.dispatch("updateMappedOurLegalEntities"),
    ])
    this.tableLoading = false
  },
};
</script>

<style>
.clickable-row {
  cursor: pointer;
}
</style>
